
import React from 'react'

 const AddressMap=()=>{
    return (
        <div className="google-map-code">
          <iframe title="Ubicacion" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.603036786578!2d-84.0552118!3d9.966947300000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8fa0e4596d9d3d2f%3A0x572a37067048798f!2sIPICIM!5e0!3m2!1sen!2scr!4v1662228656112!5m2!1sen!2scr" width="100%" height="200" frameborder="0" style={{border:0}} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
    );
 }

 export default AddressMap
